import React from 'react';
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  ExpandLessIcon,
  MenuIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';
import PropertySearchMenu from './PropertySearchMenu';
import UserMenu from './UserMenu';
import GlobalSearch from './GlobalSearch';

const MAX_COMMIT_MESSAGE_LENGTH = 60;

const ToolbarChildren = ({
  open,
  setOpen,
  isXs,
  userMenuAnchorRef,
  userMenuOpen,
  handleUserMenuToggle,
  handleUserMenuClose,
  logout,
  selectedProperty,
  onSelectProperty,
  onSelectPortfolioSummary,
  fullName,
  userProperties,
  flags: { leftsideNavButton, globalSearch },
  availableUsers,
  currentUserId,
  azureIdToken,
  showUserPicker,
  onSwitchUser,
  onSelectUser,
  onHideUserPicker,
  commitMessage,
  commitSha,
  environmentName,
}) => {
  const showCommitInfo = Boolean(
    environmentName && (commitMessage || commitSha),
  );
  const shortSha = commitSha ? commitSha.slice(0, 7) : null;
  const isTruncated =
    commitMessage && commitMessage.length > MAX_COMMIT_MESSAGE_LENGTH;
  const displayMessage = isTruncated
    ? `${commitMessage.slice(0, MAX_COMMIT_MESSAGE_LENGTH)}…`
    : commitMessage;
  const tooltipText = [commitSha, commitMessage].filter(Boolean).join('\n');

  return (
    <Stack direction="row" alignItems="center" width="100%">
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={() => setOpen(!open)}
        sx={{
          ml: 0.5,
          mr: 1,
          ...(leftsideNavButton && {
            display: { md: 'none' },
          }),
        }}
      >
        {open ? (
          <ExpandLessIcon sx={{ transform: 'rotate(-90deg)' }} />
        ) : (
          <MenuIcon />
        )}
      </IconButton>

      <PropertySearchMenu
        selectedProperty={selectedProperty}
        onSelectProperty={onSelectProperty}
        onSelectPortfolioSummary={onSelectPortfolioSummary}
        userProperties={userProperties}
      />

      {showCommitInfo && (
        <Tooltip title={tooltipText} placement="bottom">
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.75}
            sx={{ ml: 2, display: { xs: 'none', md: 'flex' }, minWidth: 0 }}
          >
            {shortSha && (
              <Typography
                variant="labelSmall"
                sx={{
                  color: 'inherit',
                  opacity: 0.7,
                  fontFamily: 'monospace',
                  flexShrink: 0,
                }}
              >
                {shortSha}
              </Typography>
            )}
            {displayMessage && (
              <Typography
                variant="labelSmall"
                sx={{
                  color: 'inherit',
                  opacity: 0.85,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {displayMessage}
              </Typography>
            )}
          </Stack>
        </Tooltip>
      )}

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        flexGrow={1}
        spacing={2}
      >
        {globalSearch && <GlobalSearch />}
        <UserMenu
          userMenuAnchorRef={userMenuAnchorRef}
          userMenuOpen={userMenuOpen}
          handleUserMenuToggle={handleUserMenuToggle}
          handleUserMenuClose={handleUserMenuClose}
          logout={logout}
          fullName={fullName}
          isXs={isXs}
          availableUsers={availableUsers}
          currentUserId={currentUserId}
          azureIdToken={azureIdToken}
          showUserPicker={showUserPicker}
          onSwitchUser={onSwitchUser}
          onSelectUser={onSelectUser}
          onHideUserPicker={onHideUserPicker}
        />
      </Stack>
    </Stack>
  );
};

export default ToolbarChildren;
